document.querySelectorAll(".component-hub-slideshow[id]").forEach(function(el) {
  new Swiper("#" + el.id, {
    slidesPerView: 1.5,
    spaceBetween: 10,
    breakpoints: {
      768: { slidesPerView: 3 },
      990: { slidesPerView: 4 }
    },
    navigation: {
      nextEl: "#" + el.id + " .swiper-button-next",
      prevEl: "#" + el.id + " .swiper-button-prev"
    }
  });
});

document.querySelectorAll(".round-image-teaser[id]").forEach(function(el) {
  new Swiper("#" + el.id, {
    slidesPerView: 1.5,
    spaceBetween: 24,
    breakpoints: {
      600: { slidesPerView: 3.5, spaceBetween: 32 },
      990: { slidesPerView: 4.5, spaceBetween: 40 }
    },
    navigation: {
      nextEl: "#" + el.id + " .swiper-button-next",
      prevEl: "#" + el.id + " .swiper-button-prev"
    }
  });
});
